import React from 'react'
import { useFAQ, FAQProps } from './useFAQ'
import styles from './FAQ.module.scss'
import TitleSection from 'components/TitleSection/TitleSection'
import faqImg from 'img/Landing/faq.webp'
import FAQItem from 'components/FAQItem/FAQItem'

const FAQ: React.FC<FAQProps> = (props: FAQProps) => {
  const {
    Tabs,
    activeTab,
    generalFAQs,
    accountFAQs,
    billingFAQs,
    handleActiveTab,
  } = useFAQ(props)

  return (
    <section id='faq' className={styles.faq}>
      <TitleSection
        title='Frequently Asked Questions'
        descriptionTitle='Frequently Asked Questions'
        description='Find answers to the most common questions about setting up and managing your digital restaurant menu.'
      />

      <div className='container'>
        <div className='row align-items-start gy-4'>
          <div className='col-lg-5'>
            <div className={styles['faq-sidebar']}>
              <div className={styles['faq-image']}>
                <img
                  src={faqImg}
                  alt='FAQ Image'
                  className='img-fluid'
                  loading='lazy'
                />
              </div>
              <div className={styles['contact-box']}>
                <h3>
                  <i className='bi bi-headset'></i> Need Assistance?
                </h3>
                <p>
                  Still have questions or need help with your account? Our
                  support team is here to assist you — just click below to get
                  in touch.
                </p>
                <a href='#contact' className={styles['btn-contact']}>
                  Connect with Support
                </a>
              </div>
            </div>
          </div>

          <div className='col-lg-7'>
            <div className={styles['faq-tabs']}>
              <ul
                className={`nav nav-pills ${styles['nav-pills']} mb-4`}
                id='faqTabs-faq'
                role='tablist'
              >
                <li
                  className={`nav-item ${styles['nav-item']}`}
                  role='presentation'
                >
                  <button
                    className={`nav-link ${styles['nav-link']} ${
                      activeTab === Tabs.General
                        ? styles.active + ' active'
                        : ''
                    }`}
                    id='general-tab-faq'
                    data-bs-toggle='pill'
                    data-bs-target='#general-faq-faq'
                    type='button'
                    role='tab'
                    aria-controls='general-faq-faq'
                    aria-selected='true'
                    onClick={() => handleActiveTab(Tabs.General)}
                  >
                    General Inquiries
                  </button>
                </li>
                <li
                  className={`nav-item ${styles['nav-item']}`}
                  role='presentation'
                >
                  <button
                    className={`nav-link ${styles['nav-link']} ${
                      activeTab === Tabs.Account
                        ? styles.active + ' active'
                        : ''
                    }`}
                    id='account-tab-faq'
                    data-bs-toggle='pill'
                    data-bs-target='#account-faq-faq'
                    type='button'
                    role='tab'
                    aria-controls='account-faq-faq'
                    aria-selected='false'
                    tabIndex={-1}
                    onClick={() => handleActiveTab(Tabs.Account)}
                  >
                    Account Services
                  </button>
                </li>
                <li
                  className={`nav-item ${styles['nav-item']}`}
                  role='presentation'
                >
                  <button
                    className={`nav-link ${styles['nav-link']} ${
                      activeTab === Tabs.Billing
                        ? styles.active + ' active'
                        : ''
                    }`}
                    id='payment-tab-faq'
                    data-bs-toggle='pill'
                    data-bs-target='#payment-faq-faq'
                    type='button'
                    role='tab'
                    aria-controls='payment-faq-faq'
                    aria-selected='false'
                    tabIndex={-1}
                    onClick={() => handleActiveTab(Tabs.Billing)}
                  >
                    Billing &amp; Payments
                  </button>
                </li>
              </ul>

              <div
                className={`tab-content ${styles['tab-content']}`}
                id='faqTabsContent-faq'
              >
                <div
                  className='tab-pane fade show active'
                  id='general-faq-faq'
                  role='tabpanel'
                  aria-labelledby='general-tab-faq'
                >
                  <div
                    className={`accordion ${styles.accordion}`}
                    id='generalAccordion-faq'
                  >
                    {generalFAQs.length ? (
                      generalFAQs.map((faq, i) => (
                        <FAQItem
                          key={`general-faq-${i}`}
                          question={faq.question}
                          answer={faq.answer}
                        />
                      ))
                    ) : (
                      <div style={{ color: 'var(--footer-color)' }}>
                        Nothing Found Here!
                      </div>
                    )}
                  </div>
                </div>

                <div
                  className='tab-pane fade'
                  id='account-faq-faq'
                  role='tabpanel'
                  aria-labelledby='account-tab-faq'
                >
                  <div
                    className={`accordion ${styles.accordion}`}
                    id='accountAccordion-faq'
                  >
                    {accountFAQs.length ? (
                      accountFAQs.map((faq, i) => (
                        <FAQItem
                          key={`account-faq-${i}`}
                          question={faq.question}
                          answer={faq.answer}
                        />
                      ))
                    ) : (
                      <div style={{ color: 'var(--footer-color)' }}>
                        Nothing Found Here!
                      </div>
                    )}
                  </div>
                </div>

                <div
                  className='tab-pane fade'
                  id='payment-faq-faq'
                  role='tabpanel'
                  aria-labelledby='payment-tab-faq'
                >
                  <div
                    className={`accordion ${styles.accordion}`}
                    id='paymentAccordion-faq'
                  >
                    {billingFAQs.length ? (
                      billingFAQs.map((faq, i) => (
                        <FAQItem
                          key={`billing-faq-${i}`}
                          question={faq.question}
                          answer={faq.answer}
                        />
                      ))
                    ) : (
                      <div style={{ color: 'var(--footer-color)' }}>
                        Nothing Found Here!
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FAQ
